<template>
    <VJoyWrapper direction="row" align="center" no-margin justify="center" class="branded-visual">
        <VJoyBlockSkeleton v-if="isLoading" class="branded-visual__placeholder" />
        <img
            v-show="!isLoading"
            :src="imageUrl"
            alt="branded-visual"
            class="branded-visual__image"
            @load="isLoading = false"
            @error="isLoading = false"
        />
        <VJoyIconButton
            icon="download"
            variant="secondary"
            size="medium"
            :loading="isLoading"
            class="branded-visual__download"
            data-testid="share-profile-download-branded-visual"
            @click="handleDownload"
        />
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {ref, computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {MaltImg} from '#components';
    import {VJoyIconButton, VJoyWrapper, VJoyBlockSkeleton} from '@maltjoy/core-vue';
    import {useProfileTracking} from '~/composables/useProfileTracking';
    import {useBrandedVisualStore} from '~/features/share-profile/store/useBrandedVisualStore';
    import {useProfileStore} from '~/store/profileStore';

    const {profile} = storeToRefs(useProfileStore());
    const {hash} = storeToRefs(useBrandedVisualStore());
    const {trackProfileSocialShareImageDownloaded} = useProfileTracking();
    const isLoading = ref(true);

    const imageUrl = computed(() => `/profile/branded-visual/${profile.value?.seoAlias}/png/${hash.value}`);

    async function handleDownload() {
        const response = await fetch(imageUrl.value);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = `${profile.value?.seoAlias || 'profile'}-branded-visual.png`;
        link.click();
        URL.revokeObjectURL(objectUrl);
        trackProfileSocialShareImageDownloaded(profile.value?.accountId || '');
    }
</script>

<style lang="scss">
    .branded-visual {
        &__image {
            width: clamp(150px, 35vh, 340px);
            height: clamp(150px, 35vh, 340px);
            object-fit: contain;
            border-radius: var(--joy-core-radius-3);
        }

        &__placeholder {
            width: clamp(150px, 35vh, 340px);
            height: clamp(150px, 35vh, 340px);
            border-radius: var(--joy-core-radius-3);
            background-color: var(--joy-color-background-disabled);
        }
    }
</style>
